// Generated types for Project
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { IslandRootReadAPI, IslandRootWriteAPI } from '../../shared/types/islandroot';
import { RFLPElementReadAPI, RFLPElementWriteAPI } from './rflpelement';
import { SecurityScopeReadAPI, SecurityScopeWriteAPI } from '../../shared/types/securityscope';
import { IslandRootReadAPISchemaObject, IslandRootWriteAPISchemaObject } from '../../shared/types/islandroot';
import { RFLPElementReadAPISchemaObject, RFLPElementWriteAPISchemaObject } from './rflpelement';
import { SecurityScopeReadAPISchemaObject, SecurityScopeWriteAPISchemaObject } from '../../shared/types/securityscope';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface ProjectReadAPI extends RFLPElementReadAPI, IslandRootReadAPI, SecurityScopeReadAPI {
  /** Retired: kept for the islands that use it, never used anew — a new link or reference to it is refused. */
  retired?: boolean;
}

export interface ProjectWriteAPI extends RFLPElementWriteAPI, IslandRootWriteAPI, SecurityScopeWriteAPI {
  /** Retired: kept for the islands that use it, never used anew — a new link or reference to it is refused. */
  retired?: boolean;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const ProjectReadAPISchema: z.ZodType<ProjectReadAPI> = RFLPElementReadAPISchemaObject.extend(IslandRootReadAPISchemaObject.shape).extend(SecurityScopeReadAPISchemaObject.shape).extend({
  retired: z.boolean().optional(),
}).passthrough();

export const ProjectWriteAPISchema: z.ZodType<ProjectWriteAPI> = RFLPElementWriteAPISchemaObject.extend(IslandRootWriteAPISchemaObject.shape).extend(SecurityScopeWriteAPISchemaObject.shape).extend({
  retired: z.boolean().optional(),
}).passthrough();
